export const SR_STATUS = {
  Submitted: 'Submitted',
  Scheduled: 'Scheduled',
  EnRoute: 'En Route',
  OnHold: 'On Hold',
  InProgress: 'In Progress',
  Resolved: 'Resolved',
  Declined: 'Declined',
  Closed: 'Closed',
  Archive: 'Archive',
  Assigned: 'Assigned',
  UnderReview: 'Under Review',
  Approved: 'Approved',
  OneYearWarranty: 'One Year Warranty',
} as const;

export type SRStatus = (typeof SR_STATUS)[keyof typeof SR_STATUS];

export const RESOLVED_BUCKET: SRStatus[] = [
  SR_STATUS.Resolved,
  SR_STATUS.Closed,
  SR_STATUS.Declined,
];
